import { render, staticRenderFns } from "./UploadVideoForm.vue?vue&type=template&id=667ddcc6"
import script from "./UploadVideoForm.vue?vue&type=script&lang=js"
export * from "./UploadVideoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports